import * as React from 'react';
import { useState, useEffect } from "react";
import ProductDetailAPICall from "../../../service/ProductDetailAPICall";
import { useForm } from 'react-hook-form';
import { useSelector } from "react-redux";
import Modal from "../Modal";
import System from 'src/helper/system';
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
const SendEmailOfReportError = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const [status, SetStatus] = useState(false);
    const [{ SendEmailOfReportError }, { }, { }] = useDOMAttachToSystemStore();
    useEffect(() => {
        if (SendEmailOfReportError) {
            SetStatus(true)
        }
    }, [SendEmailOfReportError]);
    const onHide = (action = true) => {
        SetStatus(false)
    };

    const emailPattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const productDetail = useSelector((state) => state.entities.model_ProductDetail.setProductDetail.data)

    const { register, handleSubmit, formState: { errors } } = useForm();

    let partNo = productDetail && productDetail.value && productDetail.value.ERPMFRPartNumber && productDetail.value.ERPMFRPartNumber !== null && productDetail.value.ERPMFRPartNumber.trim() !== '' ? productDetail.value.ERPMFRPartNumber : '-'
    let manufacturerName = productDetail && productDetail.value && productDetail.value.ManufacturerName && productDetail.value.ManufacturerName !== null && productDetail.value.ManufacturerName.trim() !== '' ? productDetail.value.ManufacturerName : '-'
    let productDescription = productDetail && productDetail.value && productDetail.value.ShortDescription && productDetail.value.ShortDescription !== null && productDetail.value.ShortDescription.trim() !== '' ? productDetail.value.ShortDescription : '-'

    const validateTypeofError = () => {
        var typeofErrorCheckboxes = document.getElementsByName("typeofError");
        var okay = false;

        for (var i = 0, len = typeofErrorCheckboxes.length; i < len; i++) {
            if (typeofErrorCheckboxes[i].checked) {
                okay = true;
                break;
            }
        }

        if (okay) {
            return true
        } else {
            return false
        }
    }

    const onSubmit = async (data) => {

        let reqBody = {
            "partNo": partNo,
            "manufacturerName": manufacturerName,
            "productDescription": productDescription,
            "typeofError": JSON.stringify(data.typeofError),
            "additionalInformation": data.information,
            "name": data.name,
            "email": data.email
        }
        let res = {}
        await new ProductDetailAPICall().sendReportErrorEmail(reqBody).then(function (response) {
            res = response.data;
            System.popup('ThankYouPopup', { isPDP: true });
        });
    }

    return (
        <>
            <Modal show={status} onHide={() => {
                onHide()
            }}>
                <div className="avnet-modal modal-630" id="sendMailModal">
                    <div className="avnet-modal-inner">
                        {/* Modal Header */}
                        <button type="button" className="close" data-dismiss="modal"
                            onClick={() => {
                                onHide()
                            }}>×
                        </button>
                        <div className="modal-header justify-content-center">
                            <h2 className="pcn-modal-heading text-darkgreen">Report Error</h2>
                        </div>
                        {/* Modal body */}
                        <div className="modal-body">
                            <form id="hook-form" onSubmit={handleSubmit(onSubmit)}>
                                <p className="mb-1 font-14">Thank you for assisting the Avnet.com team in improving our
                                    website and product data.Your feedback on any errors is much appreciated</p>
                                <div className="label-value mb-3">
                                    <div className="label-value-item">
                                        <label>Part No.</label>
                                        <span>{partNo}</span>
                                    </div>
                                    <div className="label-value-item">
                                        <label>Manufacturer Name:</label>
                                        <span>{manufacturerName}</span>
                                    </div>
                                    <div className="label-value-item">
                                        <label>Product Description:</label>
                                        <span>{productDescription}</span>
                                    </div>
                                </div>
                                <div className="row m-0">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <label htmlFor="email"><b>Type of Error (select all that apply)</b> <span
                                                className="mandatory">*</span></label>
                                            <div className="form-check">
                                                <input type="checkbox" className="form-check-input" id="customCheck1"
                                                    name="typeofError" value="Product Description / Attribute"
                                                    {...register("typeofError", {
                                                        required: false,
                                                        validate: validateTypeofError
                                                    })} />
                                                <label className="form-check-label" htmlFor="customCheck1">Product
                                                    Description / Attribute</label>
                                            </div>
                                            <div className="form-check">
                                                <input type="checkbox" className="form-check-input" id="customCheck2"
                                                    name="typeofError" value="Image / Schematic"
                                                    {...register("typeofError", {
                                                        required: false,
                                                        validate: validateTypeofError
                                                    })} />
                                                <label className="form-check-label" htmlFor="customCheck2"> Image /
                                                    Schematic</label>
                                            </div>
                                            <div className="form-check">
                                                <input type="checkbox" className="form-check-input" id="customCheck3"
                                                    name="typeofError" value="Datasheet"
                                                    {...register("typeofError", {
                                                        required: false,
                                                        validate: validateTypeofError
                                                    })} />
                                                <label className="form-check-label"
                                                    htmlFor="customCheck3">Datasheet</label>
                                            </div>
                                            <div className="form-check">
                                                <input type="checkbox" className="form-check-input" id="customCheck4"
                                                    name="typeofError" value="Search / Navigation"
                                                    {...register("typeofError", {
                                                        required: false,
                                                        validate: validateTypeofError
                                                    })} />
                                                <label className="form-check-label" htmlFor="customCheck4">Search /
                                                    Navigation</label>
                                            </div>
                                            <div className="form-check">
                                                <input type="checkbox" className="form-check-input" id="customCheck5"
                                                    name="typeofError" value="Alternative / Substitutes Products"
                                                    {...register("typeofError", {
                                                        required: false,
                                                        validate: validateTypeofError
                                                    })} />
                                                <label className="form-check-label" htmlFor="customCheck5">Alternative /
                                                    Substitutes Products</label>
                                            </div>
                                            <div className="form-check">
                                                <input type="checkbox" className="form-check-input" id="customCheck6"
                                                    name="typeofError" value="Pricing"
                                                    {...register("typeofError", {
                                                        required: false,
                                                        validate: validateTypeofError
                                                    })} />
                                                <label className="form-check-label"
                                                    htmlFor="customCheck6">Pricing</label>
                                            </div>
                                            <div className="form-check">
                                                <input type="checkbox" className="form-check-input" id="customCheck7"
                                                    name="typeofError" value="Other"
                                                    {...register("typeofError", {
                                                        required: false,
                                                        validate: validateTypeofError
                                                    })} />
                                                <label className="form-check-label" htmlFor="customCheck7">Other</label>
                                            </div>
                                            <p className="error">{errors.typeofError?.type === 'validate' && "Please check at least one type of error."}</p>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group">
                                                <label htmlFor="Information">Additional Information (optional)</label>
                                                <textarea name="information" rows={8} cols={60}
                                                    className="avnet-textBox form-control h-auto"
                                                    placeholder="Comments" id="Comments" {...register("information", { required: false, maxLength: 999 })} />
                                                <p className="error">{errors.information?.type === 'maxLength' && "Please enter a valid Additional Information, Max character exceeded"}</p>

                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="name">Name <span
                                                className="mandatory">*</span></label>
                                            <input type="text" name="name" aria-label="Share via Name" id="name"
                                                size={60} className="avnet-textBox form-control" placeholder="Name"
                                                {...register("name", { required: true })} />
                                            <p className="error">{errors.name?.type === 'required' && "Name field cannot be empty."}</p>
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="email">Email <span
                                                className="mandatory">*</span></label>
                                            <input type="text" name="email" aria-label="Share via email" id="email"
                                                size={60} className="avnet-textBox form-control h-auto"
                                                placeholder="Email"
                                                {...register("email", { required: true, pattern: emailPattern })} />
                                            <p className="error">{errors.email?.type === 'required' && "Please add Email"}</p>
                                            <p className="error">{errors.email?.type === 'pattern' && "Please enter a valid Email"}</p>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        {/* Modal footer */}
                        {__check(['SEND_REPORT_ERROR_EMAIL_API_CALL']).render}
                        {!__check(['SEND_REPORT_ERROR_EMAIL_API_CALL']).status &&
                            <div className="modal-footer text-center">
                                <div className="modal-footer-actions">
                                    <button type="button" className="bs5 btn btn-secondary minw-auto" data-bs-toggle="modal"
                                        data-bs-target="#ReportModal"
                                        onClick={() => {
                                            onHide()
                                        }}>
                                        Cancel
                                    </button>
                                    <button type="submit" className="bs5 btn btn-primary minw-auto" data-bs-toggle="modal"
                                        data-bs-target="#ReportModal" form="hook-form">
                                        Submit
                                    </button>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </Modal>
        </>
    );
}

export default SendEmailOfReportError;